import React from "react";
import * as S from "./styled";
import Space from "components/common/space";
import T from "@marginly/ui/components/typography";
import { formatNum } from "util/format";
import { BADGES_CAMELOT } from "components/leaderboard/hooks/use-rating";
import Label from "@marginly/ui/components/label";

interface Props {}

export function PrizesSection() {
  return (
    <div>
      <S.TextCenter>
        <T className="headerL" as="h2">
          Compete for $5,500{" "}
          <span style={{ whiteSpace: "nowrap" }}>worth of prizes</span>
        </T>
        <Space height={10} heightMobile={8} />
        <T secondary body>
          Top 50 users will get rewards in ARB tokens.
        </T>
      </S.TextCenter>
      <Space height={68} heightMobile={48} />
      <S.BadgesBoxOverflow>
        <S.BadgesBox>
          {BADGES_CAMELOT.map((item, key) => {
            return (
              <S.Badge key={key}>
                <T body>Rank #{item.position}</T>
                <Space height={24} heightMobile={24} />
                <img
                  src={`/contest/images/prizes/${item.src}.png`}
                  alt=""
                  className="main-picture"
                />
                <Space height={24} heightMobile={24} />
                <Label accent lg className="label">
                  ${formatNum(item.prize)}
                </Label>
              </S.Badge>
            );
          })}
        </S.BadgesBox>
      </S.BadgesBoxOverflow>
    </div>
  );
}
